var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
function getTitle(type) {
    switch (type) {
        case 'accomodation':
            return 'A representative will contact student shortly. Till then, track status of your request';
        case 'gic':
            return 'You can also track the status of the gic application';
        case 'loan':
            return 'You can also track the status of the loan application';
        default:
            return 'You can also track the status of the application';
    }
}
var TrackRequestStatusCard = function (_a) {
    var _b;
    var type = _a.type, title = _a.title, buttonProps = _a.buttonProps, onClick = _a.onClick;
    return (React.createElement("div", { className: "lfc-py-3 lfc-flex lfc-flex-col lfc-px-4 lfc-gap-y-4 lfc-flex-gap-4 lfc-bg-white lfc-rounded-lg lfc-shadow-vas-status-card lfc-border-[0.5px] lfc-border-primary-100 lfc-w-fit" },
        React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gray-800 " }, title !== null && title !== void 0 ? title : getTitle(type)),
        React.createElement(Button, __assign({ onClick: onClick, endIcon: React.createElement(ArrowForwardIcon, null), className: "lfc-w-fit" }, buttonProps), (_b = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.title) !== null && _b !== void 0 ? _b : 'Track status')));
};
export default TrackRequestStatusCard;
//# sourceMappingURL=TrackRequestStatusCard.js.map